import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';



const pageSize =5;
const TecAddRoleMain = () => {

  const[Roletable, setRoletable] =useState([])  
  const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1); 
  const token = JSON.parse(localStorage.getItem('usertoken')); 

  useEffect(()=>{
    getRole();
   
  },[])

  /*---Get Roles ----*/

function getRole(){


  fetch(`${BASE_URL}/Tec/GetTecRole`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

        .then(response => response.json())


          .then(data => {
           console.log("Role",data)
           setRoletable(data)
           setpaginatedPosts(_(data).slice(0).take(pageSize).value());
            localStorage.setItem("Data", JSON.stringify(data));
          });
         }

         const pageCount = Roletable? Math.ceil(Roletable.length/pageSize) :0;
// if (pageCount === 1)
// return null;

const pages = _.range(1, pageCount+1)

const pagination =(pageNo)=>{

  // if (pageCount === 1)
// return null;
setcurrentPage(pageNo);
const startIndex = (pageNo - 1) * pageSize;
const paginatedPost = _(Roletable).slice(startIndex).take(pageSize).value();
setpaginatedPosts(paginatedPost)
}
const onNext = () => {


  pagination(currentPage + 1);
};

const onPrevious = () => {
  pagination(currentPage - 1);
};
    // -----AddRole-----//


function handlesumbmit(){

  let alldata = localStorage.getItem("Data");
  let RoleName= document.getElementById("RoleName").value
 // console.log(alldata.role)

  let roledata =  JSON.parse(alldata);
console.log(roledata)


  let names = roledata.map((item) => item.role);
  console.log(names)


  let result = names.includes(RoleName);  
  console.log(result)  


 if(!RoleName){

  document.getElementById("ErrA").innerHTML="Role Required"
  document.getElementById("frown").style.display="block"
  document.getElementById("smile").style.display="none"

 }
 else if(RoleName){

  document.getElementById("ErrA").innerHTML=" "
  if(result==true){
    // toast.error(" Role Already Exists! ")

    setAlreadyErrToast(true)
    setTimeout(() => {
      setAlreadyErrToast(false)
    },3000);

   }
   else{

 

  const body ={

   Role:RoleName,
  }
 console.log(body);



axios({

  method: "POST",

  url: `${BASE_URL}/Tec/TecAddRole`,
  data:body,
  headers: {
    
    'Content-Type': 'multipart/form-data' ,    
    "Authorization": "Bearer " +`${token}`
   
  }

})

.then((response) =>{
  console.log(response.data);
   if(response.data.status === "Success"){
    closeAddForm()
    setcurrentPage(1)
    setSuccessToast(true)
    //  toast.success("Role Added Successfully!", {
    //          position: "top-center",
    //          autoClose: 3200,
    //          hideProgressBar: false,
    //          closeOnClick: true,
    //          pauseOnHover: true,
    //          draggable: true,
    //          progress: undefined,
    //          className: 'toast-message'
    //          });
             setTimeout(() => {
                 
              setSuccessToast(false)
                //  window.location.reload();
                getRole();
              

             }, 3000);
           }
          
          })
   
 .catch(error => {
  console.log(error);
   alert(" Add Role failed !")       
   })

  }
}
 }




function handlechange(){

  var RoleName= document.getElementById("RoleName").value
 if(!RoleName){

  document.getElementById("ErrA").innerHTML="Role Required"
  document.getElementById("frown").style.display="block"
  document.getElementById("smile").style.display="none"
 }
 else if(RoleName){

  document.getElementById("ErrA").innerHTML=" "
  document.getElementById("frown").style.display="none"
  document.getElementById("smile").style.display="block"
 }
}
function openForm(){

  document.getElementById("modalRegisterForm").style.display="block"
}
function closeAddForm(){
  document.getElementById("Roleform").reset();
  document.getElementById("smile").style.display="none"
  document.getElementById("frown").style.display="none"
  document.getElementById("modalRegisterForm").style.display="none"
  document.getElementById("ErrA").innerHTML=" "
}

//  RoleAction

const[roleAction,setRoleAction] = useState();

function updateRoleAction(Id){
     
  let arr = [];
  let checkboxes = document.querySelectorAll("input[type='checkbox']:checked");
 
 checkboxes.forEach((item)=>{
    arr.push(item.value)
 }) 
console.log(arr)


  var checkboxInput = arr.toString();
     
  const body ={
  
    RoleAction: checkboxInput,      
    Id:Id     
  
   }
   console.log(body);
  
   
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: `${BASE_URL}/Tec/UpdateRoleAction`,
       data:body,
       headers: {             
         'Content-Type': 'multipart/form-data' , 
         "Authorization": "Bearer " + `${token}`,
       }
     
     })
     .then((response) =>{
      console.log(response.data);
              
      // toast.success("Assigned!");
      setAssignToast(true)
      uncheckAll()
      getRole()
      setcurrentPage(1)
      setTimeout(() => {
        setAssignToast(false)
        setcurrentPage(1)
      },2000);
       }) 
      }
      function uncheckAll() {
        var inputs = document.querySelectorAll('.checkboxInput');
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].checked = false;
        }
    }


      //function closeform

      function closeForm(){

        document.getElementById("modaldeleteForm").style.display ="None"

      }
//  deletestatus

function DeleteStatus(Id,Role){

//confirm delete



const body ={
id: Id
}
console.log(body)
axios({

method:"POST",
url:`${BASE_URL}/Tec/DeletetecRole`,
data:body,
headers: {
"Content-Type" : "application/json",
"Authorization": "Bearer " + `${token}`

}

})
.then((response) =>{
console.log(response.data);
// toast.info(  "Deleted"+" " + Role +  "!",  {
// position: "top-center",
// autoClose: 3200,
// hideProgressBar: false,
// closeOnClick: true,
// pauseOnHover: true,
// draggable: true,
// progress: undefined,
// className: 'toast-message'
// });
closeForm();
setcurrentPage(1)
setDeleteErrToast(true)
setTimeout(() => {
  setDeleteErrToast(false)
  setcurrentPage(1)
  getRole();
}, 2000);


})

}  


///select particular
const [Edittec, setEdittec] =useState([])

function SelectParticular(Id){
const body =
{
  
 id:Id
}
console.log('body',body);


axios({
       method:"POST",
       url :`${BASE_URL}/Tec/GetTecParticularRole`,
       data:body, 
       headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + `${token}`,
        }     
    }) 
    

    .then((response) =>{
      console.log(response.data);
 
   
      setEdittec(response.data)
            
      localStorage.setItem("EditData",JSON.stringify(response.data))
      
   })
   .catch(error => {
     console.log(error);
     
   })

}




///confirm delete

function ConfirmDelete(Id){

SelectParticular(Id)
setTimeout(() => {
document.getElementById("modaldeleteForm").style.display = "block";
},1000);

}
const[SuccessToast,setSuccessToast] = useState(false); 
const[AssignToast,setAssignToast] = useState(false); 
const[AlreadyErrToast,setAlreadyErrToast] = useState(false);  
const[DeleteToast,setDeleteErrToast] = useState(false);
  return (
    <>
    <div className='tec-addmain'>

    
   
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Kdptecdashboard'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Add Role</span>
  
 
  </div>
  </div> */}
    <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">ADD ROLE </span></span>
 
 <div className='tec-addmain-back'>
  <Link to="/Tecadduser"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 
{/* 
 <hr></hr> */}
 </div>
    </div>


     {/* Toast */}
     {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Role Added Successfully</p></div>
   
  </div></div></div></div>:null}

  {/* Toast */}
  {AssignToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Assigned Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Actions Cleared Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {AlreadyErrToast?<div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"32%"}}>
  <div id="Tec-error-box">
    <div class="Tec-Toastdot"></div>
    <div class="Tec-Toastdot Tec-Toasttwo"></div>
    <div class="Tec-Toastface2">
      <div class="Tec-Toasteye"></div>
      <div class="Tec-Toasteye Tec-Toastright"></div>
      <div class="Tec-Toastmouth Tec-Toastsad"></div>
    </div>
    <div class="Tec-Toastshadow Tec-Toastmove"></div>
    <div class="Tec-Toastmessage"><h1 class="Tec-Toastalert">Error!</h1><p>Role Already Exist!</p></div>
    
  </div></div></div></div>:null}
      
    <div className='tec-addmain-add'>
      <button className='add-user' onClick={openForm}>  <i className="fa fa-address-book-o"></i>&nbsp;&nbsp;Add Role</button>
    </div>
     {/* Add Role form */}

     <div className="tec-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
       <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop:"250px"}}>

          <div className="modal-header text-center" style={{borderBottom:"none"}}>
        <h4 className="modal-title w-100 font-weight-bold">ADD ROLES</h4>
        <button type="button" className="close" onClick={closeAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
         </div>
              <form id="Roleform" onSubmit={handlesumbmit}>
              <div className="modal-body mx-4">

                  <div className="md-form mb-5" >
                  <div style={{display:"flex"}}>
                     <input type="text" className="form-control validate"  id="RoleName" onChange={handlechange} placeholder="Role"></input>
                     <span className='tec-successicon'> <i class="fa fa-smile-o" aria-hidden="true" id="smile"></i></span>
                     <span className='tec-erroricon'> <i class="fa fa-frown-o" aria-hidden="true" id="frown"></i></span>
                     </div>
                     <span id="ErrA" className='error'></span>
                  </div>
                     <span id="Error"></span>
                </div>

                  <div className="modal-footer d-flex justify-content-center">
                        <button type="submit"  className="tec-adduser-button">CREATE</button>
                  </div>

           </form>

          </div>
     </div>
    </div>

    {
   Roletable.length==0 ? <div id="TecApiFail">" No Data Found "</div>:(<div>
    <div className='tectable'>

<div class="tec-table_responsive">

  <table> 
    <thead>
   <tr>
      <th>S.No</th>
      <th>Roles</th>
      <th> Assign</th>
      <th style={{whiteSpace:"nowrap"}}> Assigned Action</th>
      <th>Action</th>
     </tr>
    </thead>

    <tbody>

 
    {paginatedPosts.map((e,index)=>
            {
              return<tr>
                <td>{index+1}</td>
                <td>{e.role}</td>
                <td style={{whiteSpace:"nowrap"}}> 

       <label><input type="checkbox" className='checkboxInput'   onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Add" />Add 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'   onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      
       <label><input type="checkbox"  className='checkboxInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Edit"/>Edit 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Delete"/>Delete 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
        <button onClick={()=>updateRoleAction(e.id)} id="Tecsetbtn">Set</button>
  
      
       </td>
      
       {e.roleAction?<td style={{whiteSpace:"nowrap"}}>{e.roleAction}</td>:<td style={{whiteSpace:"nowrap"}}>No Task Assigned</td>}
      
       <td> 
           
              
             <span><i class="fa fa-refresh" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="tecDelicon"></i></span>
             
              </td>
                 </tr>
            })} 
           

     </tbody>
     </table>
     
     </div>
    </div> 
    
    <br></br>
    {pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
       {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>
    )}
   {/* DeletePopup */}

   {Edittec.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Clear Action for <span>{e.role}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteStatus(e.id,e.role)} type='submit'>Clear</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
    </div>
    </>
  )
}

export default TecAddRoleMain
